import React, { useEffect, useState } from "react";
import { WrapPage, WrapPageContent, End, PageHeader, PageText } from './Style'
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { grades } from "keys";
import { NextButton } from "pages/School/PerformAssessment";
import { IconButton } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";

const Page = React.forwardRef((props, ref) => {
    const { hideNextButton, visibleType, children: words, title, firstPage, number, disabledNext, currentPage, handleFlipPrev } = props
    const { assessment } = useSelector(state => state.assessment)
    const { reading_assessment_grade_of_execution: grade_of_execution } = assessment || {}

    const gradeStyle = grades[grade_of_execution] || {}
    const fontsize = gradeStyle.fontsize?.[visibleType]
    const fontFamily = gradeStyle.font
    const lineHeight = gradeStyle?.lineHeight

    return (
        <React.Fragment>
            <WrapPage className="page" ref={ref}>

                <WrapPageContent className="page-content">
                    <PageHeader className="page-header" left={number % 2}>
                        <div className="number" >
                            {number}
                        </div>
                    </PageHeader>
                    {isEmpty(words) ?
                        <PageText bold={true} className="page-text" fontFamily={fontFamily} fontsize={fontsize}>
                            {"-סוֺף-"}
                        </PageText> :
                        <PageText lineHeight={lineHeight} fontFamily={fontFamily} fontsize={fontsize} className="page-text">
                            {words.map((word, index) => {
                                const { id, word_def_text, status, word_def_fe_details = {} } = word
                                const { is_title, break_line, new_page } = word_def_fe_details || {}
                                return (
                                    <React.Fragment key={index}>
                                        {word_def_text}{" "}
                                        {break_line && <br />}
                                    </React.Fragment>
                                )
                            })}
                        </PageText>}
                    {!(number % 2) && !hideNextButton &&
                        <div className="wrap-go-prev-page">
                            <div className="go-prev-page">
                                <NextButton size="small" disabled={disabledNext} action={handleFlipPrev} />
                            </div>
                        </div>}
                </WrapPageContent>

            </WrapPage>

        </React.Fragment>
    );
});

export default Page